import React from "react";
import PropTypes from "prop-types";
import OneCol, { Row } from "layouts/OneCol";
import Header from "components/views/Header";
import T from "i18n";
import PageHeading from "components/views/atoms/PageHeading";
import Footer from "components/views/atoms/Footer";
import ReactMarkdown from "react-markdown";
import TextSection from "components/views/atoms/TextSection";

const Disclaimer = ({ className }) => {
  const classes = ["Disclaimer"];
  if (className) classes.push(className);

  return (
    <OneCol className={classes.join(" ")}>
      <Header heading="Commercial" />
      <PageHeading>
        <T path="disclaimer.heading" />
      </PageHeading>

      <Row>
        <TextSection>
          <ReactMarkdown>
            {T({ path: "disclaimer.text1" })}
          </ReactMarkdown>
          <ReactMarkdown>
            {T({ path: "disclaimer.text2" })}
          </ReactMarkdown>
        </TextSection>
      </Row>

      <Footer />
    </OneCol>
  );
};

Disclaimer.displayName = "Disclaimer";

Disclaimer.propTypes = {
  className: PropTypes.string,
};

Disclaimer.defaultProps = {
  className: null,
};

export default Disclaimer;
